"use client";
import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const WhatweBanner = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,

        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const adjustHeights = () => {
      const items = document.querySelectorAll(".topsectslider_item");
      if (items.length === 0) return;

      let maxHeight = 0;

      // Reset heights for recalculation
      items.forEach((item) => {
        item.style.height = "auto";
      });

      // Find the tallest element
      items.forEach((item) => {
        const itemHeight = item.offsetHeight;
        if (itemHeight > maxHeight) maxHeight = itemHeight;
      });

      // Apply tallest height to all items
      items.forEach((item) => {
        item.style.height = `${maxHeight}px`;
      });
    };

    // Delay adjustment to ensure rendering
    setTimeout(() => {
      adjustHeights();
    }, 100);

    // Handle resize
    window.addEventListener("resize", adjustHeights);

    return () => {
      window.removeEventListener("resize", adjustHeights);
    };
  }, []);

  return (
    <div className="slider-container about_topsectslider1">
      <Slider {...settings}>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">1</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Student performance & success analytics</h3>
              <p className="indus_desc1">Unlock insights into student performance with data analytics. By tracking academic progress, attendance, and engagement, we help educators identify at-risk students early and provide the right interventions to support their success.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">2</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Attendance & engagement tracking</h3>
              <p className="indus_desc1">Monitoring attendance and engagement is vital for student success. Our analytics help schools track these metrics across classrooms and campuses, uncovering trends and offering actionable insights to boost participation and reduce absenteeism.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">3</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Resource allocation & budget optimization</h3>
              <p className="indus_desc1">Make the most of your resources with data-backed decisions. We analyze resource usage across departments, helping institutions optimize budgets, reduce waste, and allocate funds more effectively to support key initiatives.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">4</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Curriculum & program effectiveness</h3>
              <p className="indus_desc1">Measure the impact of your curriculum and programs to ensure they align with student needs and institutional goals. Our analytics provide insights into which courses drive engagement and achievement, allowing you to refine offerings for optimal results.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">5</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Enrolment & retention analysis</h3>
              <p className="indus_desc1">Understand enrolment trends and improve retention rates with insights into student demographics, application patterns, and attrition factors. Our solutions support data-informed decisions to attract and retain students effectively.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">6</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Teacher performance & development</h3>
              <p className="indus_desc1">Gain insights into teaching effectiveness and support professional development. Our analytics track key performance metrics and feedback, helping educators grow and maintain high standards in the classroom.</p>
            </div>
          </div>
        </div>
        <div>
          <div className="topsectslider_item">
            <div className="circle_top">7</div>
            <div className="topsectslider_itemmid">
              <h3 className="indus_hd1">Parental engagement & communication tools</h3>
              <p className="indus_desc1">Strengthen the partnership between schools and families with insights into parental engagement. Our solutions provide a clear view of communication trends and help schools foster better collabouration with parents for student success.</p>
            </div>
          </div>
        </div>

      </Slider >
    </div>
  );
};

export default WhatweBanner;
